import { render, staticRenderFns } from "./ModuloItem.vue?vue&type=template&id=116f9c00"
import script from "./ModuloItem.vue?vue&type=script&lang=js"
export * from "./ModuloItem.vue?vue&type=script&lang=js"
import style0 from "./ModuloItem.vue?vue&type=style&index=0&id=116f9c00&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports